import { Component, OnInit } from '@angular/core';

import { CommonService, Toast } from '../../frontend-services/common.service';

@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit{
  toast: Toast;
  activeMessage: boolean;
  constructor(
    private service: CommonService
  ) {}

  ngOnInit() {
    this.service.getToast()
      .subscribe(toast => {
        if (toast && toast.message) {
          this.toast = toast;
          this.show(toast);
        }
      });
  }

  show(toast: Toast) {
    this.activeMessage = true;
    setTimeout(() => {
      this.hide();
    }, toast.timeout);
  }

  hide() {
    this.service.toast(null);
    this.activeMessage = false;
    setTimeout(() => {
      this.toast = null;
    }, 500);
  }

  ngOnDestroy() {
    this.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/toast/toast.component.ts